import React, { Component } from "react";
import styled from "styled-components";

class SatisfactionQualitativePreview extends Component {
  constructor(props) {
    super(props);

    this.state = {
      feedback: ""
    };
  }

  render() {
    const { className, questionTwo } = this.props;
    const { feedback } = this.state;

    return (
      <div className={className}>
        <div>
          <a className="back-to-nps" id="back-to-nps">
            Update Your Score
          </a>
          <a className="ask-me-later">
            <div className="close-icon">✕</div>
            <div className="ask-me-later-text">Close</div>
          </a>
        </div>
        <div className="qualitative-question" id="qualitative-question">
          <div className="question-text">{questionTwo}</div>
          <div>
            <textarea
              id="feedback-box"
              value={feedback}
              onChange={e => this.setState({ feedback: e.target.value })}
            />
          </div>
          <div className="buttons">
            <a className="submit-button">Submit</a>
          </div>
        </div>
      </div>
    );
  }
}

export default styled(SatisfactionQualitativePreview)`
  .submit-button {
    background-color: ${props =>
      props.backgroundColor === "#FFFFFF" ? props.foregroundColor : "#FFFFFF"};
    color: ${props =>
      props.backgroundColor === "#FFFFFF" ? "#FFFFFF" : props.backgroundColor};

    &:hover {
      background-color: ${props =>
        props.backgroundColor === "#FFFFFF"
          ? props.foregroundColor
          : "#FFFFFF"};
    }
  }
`;
